export const MAX_TITLE_LENGTH = 60
export const SAVE_PERIOD = 4000
export const TAGS_LIMIT = 5

export const MARKS = {
  BOLD: 'bold',
  ITALIC: 'italic',
  CODE: 'code'
}

export const BLOCKS = {
  LINK: 'link',
  HEADING_ONE: 'heading-one',
  HEADING_TWO: 'heading-two',
  NUMBERED_LIST: 'numbered-list',
  BULLETED_LIST: 'bulleted-list',
  QUOTE: 'block-quote',
  IMAGE: 'image'
}